import React from 'react';

//IMAGES
import video from '../../assets/video/AFA - Banner.mp4';
import logo from '../../assets/logos/Logotipo.svg';
import twitter from '../../assets/icons/twitter.svg';
import linkedIn from '../../assets/icons/linkedin.svg';

//SCSS
import '../NotSignedIn/NotSignedIn.scss';

interface ServiceUnavailableProps {
    errorType?: 'service_unavailable' | 'not_authorized';
}

class ServiceUnavailable extends React.Component<ServiceUnavailableProps, {}> {
    render() {
        const isNotAuthorized = this.props.errorType === 'not_authorized';
        return (
            <div className="oficina-virtual">
                <video className="background-video" autoPlay loop muted playsInline>
                    <source src={video} type="video/mp4" />
                </video>
                <div className="overlay"></div>

                <header className="header">
                    <div className="logo">
                        <img src={logo} />
                    </div>
                </header>

                <main className="main-content">
                    <h1 className="title">
                        {isNotAuthorized ? 'Accés no autoritzat' : 'Servei no disponible'}
                    </h1>
                    <p className="subtitle">
                        {isNotAuthorized
                            ? <>L&apos;usuari no està registrat o no té permisos per accedir a aquest servei.<br />Si creieu que és un error, poseu-vos en contacte amb l&apos;administrador.</>
                            : <>El servei es troba temporalment no disponible.<br />Si us plau, torneu-ho a intentar més tard.</>
                        }
                    </p>
                </main>

                <footer className="footer">
                    <div className="social-icons">
                        <a href="https://www.linkedin.com/company/afa-andorra" className="social-link" aria-label="LinkedIn">
                            <img src={linkedIn} />
                        </a>
                        <a href="https://twitter.com/AFA_Andorra" className="social-link" aria-label="Twitter">
                            <img src={twitter} />
                        </a>
                    </div>
                    <nav className="footer-nav">
                        <a href="https://www.afa.ad/ca/avis-legal" className="footer-link">Avís legal</a>
                        <span className="separator">·</span>
                        <a href="https://www.afa.ad/ca/politica-de-cookies" className="footer-link">Política de Cookies</a>
                        <span className="separator">·</span>
                        <a href="https://www.afa.ad/ca/politica-de-privacitat" className="footer-link">Política de Privacitat</a>
                    </nav>
                    <p className="copyright">
                        Copyright © 2025 Autoritat Financera Andorrana – Tots els drets reservats
                    </p>
                </footer>
            </div>
        );
    }
}

export default ServiceUnavailable;
